import { render, staticRenderFns } from "./NavBarExpert.vue?vue&type=template&id=4be2ab4f&scoped=true&"
import script from "./NavBarExpert.vue?vue&type=script&lang=js&"
export * from "./NavBarExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be2ab4f",
  null
  
)

export default component.exports